// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/marccabezas/Desktop/Projects/choosify-landing/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/marccabezas/Desktop/Projects/choosify-landing/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-negocios-js": () => import("/Users/marccabezas/Desktop/Projects/choosify-landing/src/pages/negocios.js" /* webpackChunkName: "component---src-pages-negocios-js" */)
}

